SNI.Application.addModule('related-videos', (context) => {
  return {
    behaviors: ['load-more', 'lazy-load']
  };
});
